<script setup lang="ts">
import { inject, reactive, ref, watch } from 'vue'
import { resetObj } from '@/utils'
import { store } from '@/pinia/store'
import { onBeforeRouteLeave } from 'vue-router'
// types
import { PopupInfo } from '@/components/GlobalUgcPopup/types'
// components
import centerPop from './components/centerPop.vue'
import bottomPop from './components/bottomPop.vue'

const storeData = store()
const isShowUgcPopup = inject('isShowUgcPopup', ref(false))
const globalUgcPopupData = inject<PopupInfo>(
  'globalUgcPopupData',
  reactive({
    popupPosition: 'center',
    touchSlide: 'left', // 当弹窗position是center时，touchSlide为触摸左侧还是右侧
    showDirection: 'top', // 当弹窗position是center时，showDirection决定弹窗的显示方向
    positionTop: 0,
    actionUserInfo: {},
    popupData: [],
  }),
)
const themeVars = reactive({
  overlayBackground: 'rgba(0, 0, 0, 0.3)',
  popupBackground: 'transparent',
})

watch(
  () => isShowUgcPopup.value,
  (n) => {
    if (n) {
      storeData.globalUgcInfo.actionTimestamp = 0
    } else {
      resetObj(globalUgcPopupData, {}, true)
    }
  },
)

onBeforeRouteLeave(() => {
  if (isShowUgcPopup.value) {
    isShowUgcPopup.value = false
    return false
  }
})
</script>

<template>
  <van-config-provider :theme-vars="themeVars">
    <van-popup v-model:show="isShowUgcPopup" :position="globalUgcPopupData.popupPosition">
      <!-- 居中展示 -->
      <centerPop v-if="globalUgcPopupData.popupPosition === 'center'" />
      <!-- 底部展示 -->
      <bottomPop v-else />
    </van-popup>
  </van-config-provider>
</template>

<style scoped lang="scss">
.popup-con {
  background-color: #f5f5f5;
}
</style>
